import React, { useEffect, useState, useCallback } from 'react';
import * as Tone from 'tone';

const ThemeGenerator = ({ trigger, motif = ['E4', 'G4', 'B4', 'E5'], tempo = 90 }) => {
  const [isPlaying, setIsPlaying] = useState(false);

  const playMotif = useCallback(async () => {
    await Tone.start(); // Required for browser autoplay policies
    Tone.getTransport.bpm.value = tempo;

    const synth = new Tone.Synth({
      oscillator: { type: 'triangle' },
      envelope: { attack: 0.1, decay: 0.2, sustain: 0.3, release: 1 }
    }).toDestination();

    const motifPart = new Tone.Sequence((time, note) => {
      synth.triggerAttackRelease(note, '8n', time);
    }, motif, '4n');

    motifPart.start(0);
    Tone.getTransport.start();
    setIsPlaying(true);

    // Stop after one loop
    setTimeout(() => {
      Tone.getTransport.stop();
      motifPart.dispose();
      synth.dispose();
      setIsPlaying(false);
    }, (motif.length * 60000) / tempo);
  }, [motif, tempo]);

  useEffect(() => {
    if (trigger && !isPlaying) {
      playMotif();
    }
  }, [trigger, isPlaying, playMotif]);
  
  return (
    <div>
      <button onClick={playMotif} disabled={isPlaying}>
        Play Motif
      </button>
    </div>
  );
};

export default ThemeGenerator;